import {
    buildValidationsFromConfig,
} from '@/helpers/validation';

const config = {
    refundableAmountType: {
        name: 'Refundable Amount Type',
        required: true,
    },
};

export default buildValidationsFromConfig(config);
